import axios from "axios";

export const API_URL = "https://srinivasafleet.com/api";

const api = axios.create({baseURL: API_URL,});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();

      if (window.location.pathname !== "/login") {
        window.location.href = "/login?reason=session_revoked";
      }
    }
    return Promise.reject(error);
  }
);


const normalizeApiError = (error, fallbackMessage) => {
  const data = error.response?.data;

  if (!data) {
    return { message: fallbackMessage, errors: [] };
  }

  if (typeof data.message === "string") {
    return { message: data.message, errors: data.errors || [] };
  }

  if (typeof data.detail === "string") {
    return { message: data.detail, errors: [] };
  }

  if (data.detail && typeof data.detail === "object") {
    return {
      message: data.detail.message || fallbackMessage,
      errors: data.detail.errors || [],
    };
  }

  return { message: fallbackMessage, errors: [] };
};



export const uploadFleetFile = async (file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post(
      "/fleet-by-branch/bulk-upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },

        onUploadProgress: (progressEvent) => {
          if (!onUploadProgress) return;

          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          onUploadProgress(percent);
        },
      }
    );

    return response.data;
  } catch (error) {
    throw normalizeApiError(error, "Upload failed.");
  }
};




export const downloadFleetFile = async (params = {}) => {
  try {
    const response = await api.get(
      "/fleet-by-branch/download",
      {
        params,
        responseType: "blob",
      }
    );

    const disposition =
      response.headers["content-disposition"];

    let filename = "Fleet_By_Branch.xlsx";

    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);

      if (match) {
        filename = match[1];
      }
    }

    const blob = new Blob([response.data]);

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = filename;

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    throw normalizeApiError(error, "Download failed.");
  }
};



export const fetchFleetList = async (params = {}) => {
  try {
    const response = await api.get("/fleet-by-branch/list", { params });
    return response.data;
  } catch (error) {
    throw normalizeApiError(error, "Could not load fleet records.");
  }
};




export const fetchFleetSummary = async (params = {}) => {
  try {
    const response = await api.get("/fleet-by-branch/summary", { params });
    return response.data;
  } catch (error) {
    throw normalizeApiError(error, "Could not load summary.");
  }
};

export const updateFleetRecord = async (id, payload) => {
  try {
    const response = await api.put(`/fleet-by-branch/${id}`, payload);
    return response.data;
  } catch (error) {
    throw normalizeApiError(error, "Could not update record.");
  }
};


export const deleteFleetRecord = async (id) => {
  try {
    const response = await api.delete(`/fleet-by-branch/${id}`);
    return response.data;
  } catch (error) {
    throw normalizeApiError(error, "Could not delete record.");
  }
};